import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loadingState, setLoadingState] = useState({
    isLoading: false,
    message: '',
    progress: null
  });

  // 로딩 시작
  const startLoading = useCallback((message = '로딩 중...', progress = null) => {
    setLoadingState({
      isLoading: true,
      message,
      progress
    });
  }, []);

  // 로딩 종료
  const stopLoading = useCallback(() => {
    setLoadingState({
      isLoading: false,
      message: '',
      progress: null
    });
  }, []);

  // 진행률 업데이트
  const updateProgress = useCallback((progress, message) => {
    setLoadingState(prev => ({
      ...prev,
      progress,
      message: message || prev.message
    }));
  }, []);

  // 메시지만 업데이트
  const updateMessage = useCallback((message) => {
    setLoadingState(prev => ({
      ...prev,
      message
    }));
  }, []);

  const value = {
    ...loadingState,
    startLoading,
    stopLoading,
    updateProgress,
    updateMessage
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
};

export default LoadingContext; 